import React, { SetStateAction } from 'react';
import { useMemo } from 'react';
import { StyledDropDownMenu, StyledDropDownMenuItem } from './Header.styled';
import { Title } from './AllWatchesNavLinkDropDownMenu/AllWatches.styled';
import { OfferTypeEnum } from '../../react-pages/SellTrade/types/SellTradeForm.types';
import { useAppSelector } from '../../hooks/reduxHooks';
import LocalizedLink from '../Link/localized-link';

interface NavLinkDropDownMenuProps {
  sellTradeDropdownVisible: boolean;
  setSellTradeDropdownVisible: (value: SetStateAction<boolean>) => void;
}

export const NavLinkDropDownMenu: React.FC<NavLinkDropDownMenuProps> = ({
  sellTradeDropdownVisible,
  setSellTradeDropdownVisible,
}) => {
  const locale = useAppSelector((st) => st.locale);

  const messages = useMemo(() => {
    return {
      header_item_sell: locale['header_items_sell'],
      header_item_trade: locale['header_items_trade'],
      header_items_consignment: locale['header_items_consignment'],
    };
  }, [locale]);

  if (!sellTradeDropdownVisible) return null;

  return (
    <StyledDropDownMenu>
      <div style={{ position: 'relative', left: '41px' }}>
        <StyledDropDownMenuItem>
          <LocalizedLink
            href={`/sell-trade/${OfferTypeEnum.Sell}`}
            onClick={() => {
              setSellTradeDropdownVisible(false);
            }}
          >
            <Title>{messages.header_item_sell}</Title>
          </LocalizedLink>
        </StyledDropDownMenuItem>
        <StyledDropDownMenuItem>
          <LocalizedLink
            href={`/sell-trade/${OfferTypeEnum.Trade}`}
            onClick={() => {
              setSellTradeDropdownVisible(false);
            }}
          >
            <Title>{messages.header_item_trade}</Title>
          </LocalizedLink>
        </StyledDropDownMenuItem>
        <StyledDropDownMenuItem>
          <LocalizedLink
            href={`/consignment`}
            onClick={() => {
              setSellTradeDropdownVisible(false);
            }}
          >
            <Title>{messages.header_items_consignment}</Title>
          </LocalizedLink>
        </StyledDropDownMenuItem>
      </div>
    </StyledDropDownMenu>
  );
};
